module.exports = "<app-table-card header=\"Selected Purposes\" icon=\"target.png\" collapsible=true>\r\n  <tbody class=\"border-top-0\">\r\n    <tr>\r\n      <td *ngFor=\"let purpose of selectedPurposes; let isFirst=first\" [ngClass]=\"{'border-left': !isFirst}\"> {{ getPurposeName(purpose.portCallPurposeId) }} </td>\r\n    </tr>\r\n  </tbody>\r\n</app-table-card>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/confirmation-view/port-call-details/selected-purposes/selected-purposes.component.html
// module id = ./src/app/shared/components/confirmation-view/port-call-details/selected-purposes/selected-purposes.component.html
// module chunks = main